module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/product-images/product-05-08e4b36ede300b5a8043536c10cbb555.jpg";